// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__o1AAH","loader":"loader_loader__EKUHM","animation":"loader_animation__Hh5k_"};